import React, { useState } from 'react';

function Project({ title, description, imageUrl, demoUrl, githubUrl, shortTitle, technologies }) {
  const [showTechnologies, setShowTechnologies] = useState(false);

  return (
    <div className="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden md:max-w-2xl">
      <div className="md:flex">
        <div className="md:flex-shrink-0">
          <img className="h-48 w-full object-cover md:h-full md:w-48" src={imageUrl} alt={title} />
        </div>
        <div className="p-8 flex flex-col justify-between">
          <div>
            <div className="uppercase tracking-wide text-sm text-indigo-500 font-semibold">{title}</div>
            <p className="mt-2 text-gray-500 flex-grow">{description}</p>
          </div>
          <div className="mt-4">
            <button 
              className="text-gray-500 underline cursor-pointer focus:outline-none"
              onClick={() => setShowTechnologies(!showTechnologies)}
            >
              {showTechnologies ? 'Hide Technologies' : 'Show Technologies'}
            </button>
            {showTechnologies && (
              <p className="mt-2 text-gray-500">Technologies Used: {technologies.join(', ')}</p>
            )}
            <div className="mt-2">
              <a href={demoUrl} className="text-indigo-600 hover:text-indigo-900" title={shortTitle}>Demo</a>
              <span className="mx-2 text-gray-400">|</span>
              <a href={githubUrl} className="text-indigo-600 hover:text-indigo-900" title={shortTitle}>GitHub</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;